import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, Jsonp, URLSearchParams } from '@angular/http';
// import { User } from '../models/user';
import {AppConfig} from '../../app.config';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { Subject }    from 'rxjs/Subject';
@Injectable()
export class CityService {
    constructor(private http: Http, private config: AppConfig, private _jsonp: Jsonp) { }

    saveCity(user: any) {
      return this.http.post(this.config.apiUrl +'city/create', user, this.setHeaders()).map((response: Response) => response.json());
    }
    getAllCity(cityCurrentPage: number, maxSize: any) {
        return this.http.get(this.config.apiUrl +'city/get-all?page='+cityCurrentPage+'&limit='+maxSize, this.setHeaders()).map((response: Response) => response.json());
    }
    getAllActiveCity() {
      return this.http.get(this.config.apiUrl + 'city/get-all-active',this.setHeaders()).map((response:Response) => response.json());
    }
    deleteCity(id: any) {
        // return this.http.post(this.config.apiUrl +'admin/city/delete-city',{id:id}, this.setHeaders()).map((response: Response) => response.json());
    }
    activeCity(id:any){
        return this.http.post(this.config.apiUrl+'city/active',{id:id},this.setHeaders()).map((response:Response)=> response.json());
    }
    deActiveCity(id:any){
        return this.http.post(this.config.apiUrl+'city/deactive',{id:id},this.setHeaders()).map((response:Response)=> response.json());
    }
    updateCity(city:any) {
        return this.http.put(this.config.apiUrl +'city/update', city, this.setHeaders()).map((response: Response) => response.json());
    }
    private setHeaders(params?: any) {
        // create authorization header with jwt token
        let token = localStorage.getItem('token');
        if (token) {
            // console.log('token >>>' + token);
            let headers = new Headers({ 'x-roamingse-token': token });
            if(params)
                return new RequestOptions({ headers: headers , search : params });
            else
                return new RequestOptions({ headers: headers });
        }else{
            return new RequestOptions({});
        }
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/city.service.ts